module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0243.6a8026ee.jpg";